/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { ExternalStyles, Text, Theme, useTheme } from 'bold-ui'
import { Box } from 'components/Box'
import { ErrorField, resolveName, SimNaoRadioGroupField, TextField } from 'components/form'
import { useField } from 'react-final-form'
import { MetaPath } from 'util/metaPath'
import { isEmpty } from 'util/validation/Util'

import { ConsultaSeguimentoOutroFieldModel } from '../model-consultaSeguimento'

interface PerguntaSimNaoOutroFieldProps {
  name: MetaPath<ConsultaSeguimentoOutroFieldModel>
  direction?: 'horizontal' | 'vertical'
  hideRadioOptions?: boolean
  style?: ExternalStyles
}
export function PerguntaSimNaoOutroField(props: Readonly<PerguntaSimNaoOutroFieldProps>) {
  const { name, direction = 'horizontal', hideRadioOptions, style } = props

  const {
    input: { value },
    meta: { error },
  } = useField<ConsultaSeguimentoOutroFieldModel>(resolveName(name), {
    subscription: { value: true, error: true },
  })

  const {
    meta: { touched: textTouched },
  } = useField<string>(resolveName(name.textValue), {
    subscription: { touched: true },
  })

  const showError = textTouched && !!error?.textValue

  const theme = useTheme()
  const styles = createStyles(direction, theme, showError)

  return (
    <Box style={styles.box}>
      <div css={[styles.root, style]}>
        <TextField
          name={name.textValue}
          label={<Text fontWeight='normal'>Outro:</Text>}
          maxLength={150}
          placeholder='Descrever, se houver'
          style={styles.textField}
          error={null}
        />
        {!hideRadioOptions && (
          <div css={styles.radioWrapper}>
            <SimNaoRadioGroupField name={name.radioValue} hSpacing={0.5} disabled={isEmpty(value.textValue)} />
          </div>
        )}
      </div>
      <ErrorField name={name.textValue} style={styles.error} />
    </Box>
  )
}

const createStyles = (direction: 'horizontal' | 'vertical', theme: Theme, hasError) => ({
  root: css`
    display: grid;
    gap: 1rem;
    grid-auto-flow: ${direction === 'horizontal' ? 'column' : 'row'};
    align-items: center;
    justify-content: ${direction === 'horizontal' ? 'space-between' : 'normal'};
  `,
  textField: css`
    width: ${direction === 'horizontal' ? '27rem' : '100%'};
  `,
  box: css`
    padding: 0;
    border-color: ${hasError ? theme.pallete.status.danger.main : theme.pallete.divider};
  `,
  error: css`
    padding: 0 1rem 0.75rem 1rem;
    margin-top: -0.3rem;
    display: block;
  `,
  radioWrapper: css`
    margin-top: ${direction === 'horizontal' && hasError ? '24px' : '0px'};
  `,
})
